// pages/CancelPage/CancelPage.jsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './CancelPage.module.css'

const CancelPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to dashboard after short delay (optional)
    const timer = setTimeout(() => {
      navigate('/dashboard');
    }, 1000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (<div className={styles.container}>
        <p className={styles.message}>Redirecting to dashboard...</p>
      </div>);
};

export default CancelPage;
